import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  Divider,
} from '@mui/material';

import Header from '../components/Header';
import Footer from '../components/Footer';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import axios from '../api/axios';
import DecorativeCubes from '../components/DecorativeCubes';

const SchedulePage = () => {
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);

  const dayLabels = {
    monday: 'Понедельник',
    tuesday: 'Вторник',
    wednesday: 'Среда',
    thursday: 'Четверг',
    friday: 'Пятница',
    saturday: 'Суббота',
    sunday: 'Воскресенье',
  };

  useEffect(() => {
    fetchSchedules();
  }, []);

  const fetchSchedules = async () => {
    try {
      const response = await axios.get('/schedules/public');
      setSchedules(response.data);
    } catch (error) {
      console.error('Error fetching schedules:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <>
        <Header />
        <Container maxWidth="lg" sx={{ py: 8 }}>
          <Typography variant="h5" align="center">
            Загрузка...
          </Typography>
        </Container>
        <Footer />
      </>
    );
  }

  return (
    <Box sx={{ position: 'relative' }}>
      <DecorativeCubes minCubes={8} maxCubes={12} />
      <Header />

      <Box sx={{ position: 'relative', overflow: 'hidden', minHeight: '100vh', zIndex: 2 }}>
        <Container maxWidth="lg" sx={{ py: 8, position: 'relative' }}>
          
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <AccessTimeIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
            <Typography
              variant="h2"
              sx={{ mb: 2, fontWeight: 700, color: 'primary.main' }}
            >
              График работы наших специалистов
            </Typography>
          </Box>

          {schedules.length === 0 ? (
            <Paper sx={{ p: 4, textAlign: 'center' }}>
              <Typography variant="h6" color="text.secondary">
                Расписание еще не добавлено
              </Typography>
            </Paper>
          ) : (
            <Grid container spacing={4}>
              {schedules.map((schedule) => (
                <Grid item xs={12} key={schedule._id}>
                  <Card
                    elevation={3}
                    sx={{
                      borderRadius: 4,
                      overflow: 'visible',
                      background: 'linear-gradient(135deg, #00ACC1 0%, #81C784 100%)',
                    }}
                  >
                    <CardContent sx={{ p: 4 }}>
                      
                      <Box sx={{ mb: 3, textAlign: 'center' }}>
                        <Typography
                          variant="h4"
                          sx={{ fontWeight: 700, color: 'white' }}
                        >
                          {schedule.specialistRole}
                        </Typography>
                      </Box>

                      <Divider sx={{ my: 3, backgroundColor: 'rgba(255,255,255,0.3)' }} />

                      <Grid container spacing={2}>
                        {Object.entries(schedule.schedule).map(([day, value]) => {
                          const isOff =
                            !value ||
                            value.toLowerCase().includes('выходной');

                          return (
                            <Grid item xs={12} sm={6} key={day}>
                              <Paper
                                sx={{
                                  p: 3,
                                  textAlign: 'center',
                                  backgroundColor: 'rgba(255,255,255,0.95)',
                                  borderRadius: 2,
                                  height: '100%',
                                }}
                              >
                                <Typography
                                  variant="h6"
                                  sx={{
                                    fontWeight: 700,
                                    color: 'primary.main',
                                    mb: 1,
                                  }}
                                >
                                  {dayLabels[day]}
                                </Typography>

                                <Typography
                                  variant="body1"
                                  sx={{
                                    color: isOff ? 'error.main' : 'text.secondary',
                                    fontWeight: 600,
                                  }}
                                >
                                  {value || 'Не указано'}
                                </Typography>
                              </Paper>
                            </Grid>
                          );
                        })}
                      </Grid>

                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}

        </Container>
      </Box>

      <Footer />
    </Box>
  );
};

export default SchedulePage;